import { ConsultationsQuery, useConsultationsQuery } from '@/graphql/types'
import { AuthButtons } from '@/react/shared/components/AuthButtons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { useAuth } from '../../components/AuthProvider'
import { LinkButton } from '../../components/Basics'
import { LinkConsultationCard } from '../../components/LinkConsultationCard'

export const List: React.FC = () => {
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const { loading: loadingCurrentConsulter, isLoggedIn } = useAuth()

  const {
    data: dataConsultations,
    loading: loadingConsultations,
    fetchMore,
  } = useConsultationsQuery({
    variables: {
      page: 1,
    },
  })

  const loading = loadingCurrentConsulter || loadingConsultations
  const hasNextPage = page < totalPages

  const listElement = () => {
    if (loading) return <div>Loading...</div>
    if (dataConsultations?.consultations?.nodes?.length) {
      return (
        <div className="flex flex-col gap-5">
          {dataConsultations?.consultations?.nodes?.map((consultation) => (
            <LinkConsultationCard
              key={consultation.id}
              consultation={consultation}
              lineClamp
            />
          ))}
        </div>
      )
    }
    return <div>Empty</div>
  }

  const bottomElement = () => {
    if (loading) return
    if (isLoggedIn) {
      return (
        <div className="flex justify-center">
          <LinkButton
            className="w-11/12 mx-auto focus:outline-none focus:ring focus:border-blue-300  bg-link-color hover:bg-link-color"
            href="/features/qa/mild_cognitive_impairment/consultations"
          >
            医師に相談する
          </LinkButton>
        </div>
      )
    } else {
      return (
        <>
          <AuthButtons dataMnCspLocation="本文中_01" />
        </>
      )
    }
  }

  const handleLoadMore = async () => {
    await fetchMore({
      variables: {
        page: page + 1,
      },
      updateQuery: (
        prev: ConsultationsQuery,
        options: { fetchMoreResult?: ConsultationsQuery }
      ): ConsultationsQuery => {
        if (!options.fetchMoreResult) {
          return prev
        }

        return {
          ...prev,
          consultations: {
            ...prev.consultations,
            nodes: [
              ...prev.consultations!.nodes,
              ...options.fetchMoreResult.consultations!.nodes,
            ],
            pageInfo:
              options.fetchMoreResult.consultations!.pageInfo ||
              prev.consultations!.pageInfo,
          },
        }
      },
    })
    setPage(page + 1)
  }

  useEffect(() => {
    if (dataConsultations?.consultations?.pageInfo) {
      setTotalPages(dataConsultations?.consultations?.pageInfo.pages)
    } else {
      setTotalPages(0)
    }
  }, [dataConsultations?.consultations])

  return (
    <div>
      <div className="pc:w-pc-inner-sm mx-auto">
        <h1 className="text-app-color font-bold py-8 px-4 pc:px-0 text-2xl">
          相談一覧
        </h1>
      </div>
      <div className="py-6 px-4 bg-gray-10">
        <div className="pc:w-pc-inner-sm mx-auto">
          <div>{listElement()}</div>
          {!loading && hasNextPage && (
            <button
              className="mt-6 w-full text-2xl font-bold text-link-color border-link-color bg-white focus:outline-none rounded border hover:bg-gray-100 focus:z-10 focus:ring-4 focus:ring-gray-100"
              style={{
                padding: '5px 20px',
              }}
              onClick={() => handleLoadMore()}
            >
              <FontAwesomeIcon
                style={{ fontSize: 22, marginRight: 9 }}
                icon={faChevronDown}
              />
              もっと見る
            </button>
          )}
        </div>
      </div>
      <div className="w-full pc:w-pc-inner-xs mx-auto py-8 px-4 pc:px-0">
        <p className="mb-8 text-xxs text-gray-70">
          本サービスは医師による健康相談サービスで、医師による回答は相談内容に応じた医学的助言です。診断・診察などを行うものではありません。
          このことを十分認識したうえで自己の責任において、医療機関への受診有無等をご自身でご判断ください。
          実際に医療機関を受診する際も、治療方法、薬の内容等、担当の医師によく相談、確認するようにお願いいたします。
        </p>
        {bottomElement()}
      </div>
    </div>
  )
}
